import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Login } from './onboarding/Login';
import { Dashboard } from './dashboard/Dashboard';

/**
 * Home component that routes to Dashboard if logged in, otherwise Login
 */
export const Home: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div style={{ color: '#999', fontSize: '14px' }}>Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? <Dashboard /> : <Login />;
};

export default Home;
